interface Props {
  size?: "sm" | "md" | "lg";
  withWordmark?: boolean;
  className?: string;
}

const sizeMap = {
  sm: { icon: 28, text: "text-base" },
  md: { icon: 36, text: "text-xl" },
  lg: { icon: 48, text: "text-2xl" },
};

export function Logo({ size = "md", withWordmark = true, className = "" }: Props): JSX.Element {
  const s = sizeMap[size];
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <svg
        width={s.icon}
        height={s.icon}
        viewBox="0 0 64 64"
        fill="none"
        aria-hidden="true"
      >
        <rect width="64" height="64" rx="14" fill="#0b0f14" />
        <circle cx="32" cy="32" r="22" stroke="#c5f000" strokeOpacity="0.25" strokeWidth="1.5" />
        <rect x="20" y="26" width="4" height="12" rx="2" fill="#c5f000" />
        <rect x="28" y="20" width="4" height="24" rx="2" fill="#c5f000">
          <animate attributeName="height" values="24;14;24" dur="2.4s" repeatCount="indefinite" />
          <animate attributeName="y" values="20;25;20" dur="2.4s" repeatCount="indefinite" />
        </rect>
        <rect x="36" y="14" width="4" height="36" rx="2" fill="#c5f000">
          <animate attributeName="height" values="36;22;36" dur="2.4s" begin="0.3s" repeatCount="indefinite" />
          <animate attributeName="y" values="14;21;14" dur="2.4s" begin="0.3s" repeatCount="indefinite" />
        </rect>
        <rect x="44" y="26" width="4" height="12" rx="2" fill="#c5f000" fillOpacity="0.6" />
      </svg>
      {withWordmark && (
        <span className={`font-bold tracking-tight text-white ${s.text}`}>
          tutor<span className="text-lime-500">.</span>
        </span>
      )}
    </div>
  );
}
